import {useEffect} from 'react'

export const useTurnstileScript = ({enabled = true}: {enabled?: boolean} = {}) => {
    useEffect(() => {
        if (!enabled) {
            return
        }

        if (document.querySelector('#turnstile-script')) {
            return
        }

        const script = document.createElement('script')
        script.id = 'turnstile-script'
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
        script.async = true
        script.defer = true

        try {
            document.head.appendChild(script)
        } catch (error) {
            console.error('Failed to load Cloudflare Turnstile script:', error)
        }
    }, [enabled])
}
